import { defineComponent as t, openBlock as o, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as s, renderSlot as c, createElementVNode as l } from "vue";
import m from "../CdrIcon.vue.mjs";
const d = /* @__PURE__ */ l("path", {
  role: "presentation",
  d: "M21 12a1 1 0 01-2 0A7 7 0 008.392 6H9a1 1 0 010 2H5.993A.997.997 0 015 6.971V4a1 1 0 012-.004v.52A9 9 0 0121 12zm-5.392 6H15a1 1 0 010-2h3.007A.997.997 0 0119 17.029V20a1 1 0 01-2 .004v-.52A9 9 0 013 12a1 1 0 012 .001 7 7 0 0010.608 6z"
}, null, -1), _ = /* @__PURE__ */ t({
  name: "Refresh",
  __name: "refresh",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (r, f) => (o(), a(m, n(p(e.props)), {
      default: s(() => [c(r.$slots, "default"), d]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
